import { useState, useEffect } from "react";

import { readUsers } from "@directus/sdk";
import { Modal } from "antd";
import { getDirectusClient } from "../../../lib/directus";

export function useVendors(userBodega) {
  const [vendors, setVendors] = useState([]);
  const [loadingVendors, setLoadingVendors] = useState(false);

  useEffect(() => {
    const fetchVendors = async () => {
      setLoadingVendors(true);
      try {
        const directus = await getDirectusClient();
        const response = await directus.request(
          readUsers({
            fields: ["*"],
            filter: {
              role: {
                name: { _contains: "supervisor tropas" },
              },
              bodega: { id: { _eq: userBodega } },
            },
            sort: ["first_name"],
          })
        );
        setVendors(response);
      } catch (err) {
        console.error("Error fetching vendors:", err);
        Modal.error({
          title: "Error",
          content: "Error al cargar los vendedores",
        });
      } finally {
        setLoadingVendors(false);
      }
    };
    if (userBodega) fetchVendors();
  }, [userBodega]);

  return { vendors, loadingVendors };
} 